// extracted by mini-css-extract-plugin
module.exports = {"outerZaznamProblemu":"Modal_outerZaznamProblemu__2Oyqe","ico_Title":"Modal_ico_Title__35pOO","button":"Modal_button__1WnD-","buttonArea":"Modal_buttonArea__3yArs"};